import { useEffect, useRef } from "react";
import styled from "styled-components";

import { RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { Grid } from "antd";
import { noop } from "lodash";
import { IconGlyphSvg, IconMenuSvg } from "@/assets/images";

const { useBreakpoint } = Grid;

export function ContactUsHeroSection({
	banner = {},
	onPressContactInfo = noop,
	onPressEmployment = noop,
	onPressMessageUs = noop,
	openMenu = false,
	setOpenMenu = noop,
	showMenu = false,
}) {
	const screens = useBreakpoint();
	const divRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (divRef.current && !divRef.current.contains(event.target)) {
				setOpenMenu(false); // Close if clicked outside
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	return (
		<div style={{ width: "100%", position: "relative" }}>
			<RAImage
				url={screens.xs ? banner?.mobile_banner : screens.sm ? banner?.desktop_banner : ""}
				width="100%"
				height="100vh"
				alt="contact-us-banner"
			/>
			<Overlay />
			<WrapperContent>
				<TextContainer className="animate__animated animate__fadeInUp animate__slow">
					<RATypography variant={screens?.md ? "h1" : "h2"} color="#fff" style={{ display: "inline" }}>
						{banner?.title || ""}
					</RATypography>
				</TextContainer>

				<WrapperQuote className="animate__animated animate__fadeInUp">
					{showMenu ? (
						<div
							ref={divRef}
							style={{
								display: "flex",
								flexDirection: "column",
								position: "relative",
								userSelect: "none",
							}}
						>
							<MenuButton onClick={() => setOpenMenu(!openMenu)}>
								<RAImage width="16px" height="16px" url={IconMenuSvg} alt="contact-us-menu-icon" />
								<RATypography variant="button1" color="#222222">
									MENU
								</RATypography>
							</MenuButton>
							<div
								style={{
									maxHeight: openMenu ? 200 : 0,
									overflow: "hidden",
									transition: "all 0.5s",
									display: "flex",
									flexDirection: "column",
									gap: 20,
								}}
							>
								<MenuItem
									style={{
										backgroundImage: "url('/images/bg-contact-btn-3.png')",
									}}
									onClick={() => onPressContactInfo()}
								>
									<RATypography variant="button1" color="#ffffff" style={{ fontWeight: 400 }}>
										CONTACT INFO
									</RATypography>
								</MenuItem>
								<MenuItem
									style={{
										backgroundImage: "url('/images/bg-contact-btn-2.png')",
									}}
									onClick={() => onPressEmployment()}
								>
									<RATypography variant="button1" color="#ffffff" style={{ fontWeight: 400 }}>
										EMPLOYMENT
									</RATypography>
								</MenuItem>
								<MenuItem
									style={{
										backgroundImage: "url('/images/bg-contact-btn-1.png')",
									}}
									onClick={() => onPressMessageUs()}
								>
									<RATypography variant="button1" color="#ffffff" style={{ fontWeight: 400 }}>
										MESSAGE US
									</RATypography>
								</MenuItem>
							</div>
						</div>
					) : null}
				</WrapperQuote>
			</WrapperContent>
			<WrapperAbsoluteIcon>
				<RAImage width="32px" height="32px" url={IconGlyphSvg} alt="contact-us-glyph-icon" />
			</WrapperAbsoluteIcon>
		</div>
	);
}

const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.3);
`;

const TextContainer = styled.div`
	text-align: center;
	background: linear-gradient(180deg, #ffffff 39.72%, rgba(255, 255, 255, 0) 140.65%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
`;
const WrapperContent = styled.div`
	position: absolute;
	top: 25%;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
`;
const WrapperQuote = styled.div`
	padding-top: 30px;
	max-width: 280px;
	--animate-duration: 3s;
	.menu-button {
		padding-left: 4rem;
		padding-right: 4rem;
	}
`;
const WrapperAbsoluteIcon = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	bottom: 20px;
	display: flex;
	justify-content: center;
	animation: float 3s ease-in-out infinite;
	@keyframes float {
		0% {
			transform: translateY(0px);
		}
		50% {
			transform: translateY(-10px);
		}
		100% {
			transform: translateY(0px);
		}
	}
`;
const MenuItem = styled.div`
	opacity: 0.9;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 0px;
	border-radius: 50px;
	text-align: center;
	width: 100%;
	height: 46px;
	border: 1px solid transparent;
	cursor: pointer;
	&:hover {
		border-color: #ffb11a;
	}
`;
const MenuButton = styled.div`
	background: #fff;
	width: 100%;
	padding: 15px 40px;
	margin-bottom: 20px;
	text-align: center;
	border-radius: 50px;
	height: 52px;
	width: 200px;
	display: flex;
	gap: 12px;
	align-items: center;
	justify-content: center;
	cursor: pointer;
`;
